// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import { HTTPClient } from "./client";

export type { APIConfig } from "./client";
export type { RequestOptions, WithResponse } from "./core";
export { APIError, SumUpError } from "./core";
export * from "./resources/checkouts";
export * from "./types";

import { Checkouts } from "./resources/checkouts";

export * from "./resources/customers";

import { Customers } from "./resources/customers";

export * from "./resources/members";

import { Members } from "./resources/members";

export * from "./resources/memberships";

import { Memberships } from "./resources/memberships";

export * from "./resources/merchants";

import { Merchants } from "./resources/merchants";

export * from "./resources/payouts";

import { Payouts } from "./resources/payouts";

export * from "./resources/readers";

import { Readers } from "./resources/readers";

export * from "./resources/receipts";

import { Receipts } from "./resources/receipts";

export * from "./resources/roles";

import { Roles } from "./resources/roles";

export * from "./resources/transactions";

import { Transactions } from "./resources/transactions";

export class SumUp extends HTTPClient {
  /** Access the Checkouts API endpoints. */
  checkouts: Checkouts = new Checkouts(this);
  /** Access the Customers API endpoints. */
  customers: Customers = new Customers(this);
  /** Access the Members API endpoints. */
  members: Members = new Members(this);
  /** Access the Memberships API endpoints. */
  memberships: Memberships = new Memberships(this);
  /** Access the Merchants API endpoints. */
  merchants: Merchants = new Merchants(this);
  /** Access the Payouts API endpoints. */
  payouts: Payouts = new Payouts(this);
  /** Access the Readers API endpoints. */
  readers: Readers = new Readers(this);
  /** Access the Receipts API endpoints. */
  receipts: Receipts = new Receipts(this);
  /** Access the Roles API endpoints. */
  roles: Roles = new Roles(this);
  /** Access the Transactions API endpoints. */
  transactions: Transactions = new Transactions(this);
}

export default SumUp;
